'use strict';

var positions = require('../positions'),

    videoMode720 = require('./720'),

    graphic = {
        480:  {},
        576:  {},
        720:  {},
        1080: {}
    };

// todo: optimize config computing via functions

graphic[480][positions.leftTop] = {
    width: videoMode720[480][positions.leftTop].width * 1.5,
    height: videoMode720[480][positions.leftTop].height * 1.5,
    x: videoMode720[480][positions.leftTop].x * 1.5,
    y: videoMode720[480][positions.leftTop].y * 1.5
};
graphic[480][positions.rightTop] = {
    width: graphic[480][positions.leftTop].width,
    height: graphic[480][positions.leftTop].height,
    x: videoMode720[480][positions.rightTop].x * 1.5,
    y: videoMode720[480][positions.rightTop].y * 1.5
};
graphic[480][positions.rightBottom] = {
    width: graphic[480][positions.leftTop].width,
    height: graphic[480][positions.leftTop].height,
    x: videoMode720[480][positions.rightBottom].x * 1.5,
    y: videoMode720[480][positions.rightBottom].y * 1.5
};
graphic[480][positions.leftBottom] = {
    width: graphic[480][positions.leftTop].width,
    height: graphic[480][positions.leftTop].height,
    x: videoMode720[480][positions.leftBottom].x * 1.5,
    y: videoMode720[480][positions.leftBottom].y * 1.5
};


graphic[576][positions.leftTop] = {
    width: videoMode720[576][positions.leftTop].width * 1.5,
    height: videoMode720[576][positions.leftTop].height * 1.5,
    x: videoMode720[576][positions.leftTop].x * 1.5,
    y: videoMode720[576][positions.leftTop].y * 1.5
};
graphic[576][positions.rightTop] = {
    width: graphic[576][positions.leftTop].width,
    height: graphic[576][positions.leftTop].height,
    x: videoMode720[576][positions.rightTop].x * 1.5,
    y: videoMode720[576][positions.rightTop].y * 1.5
};
graphic[576][positions.rightBottom] = {
    width: graphic[576][positions.leftTop].width,
    height: graphic[576][positions.leftTop].height,
    x: videoMode720[576][positions.rightBottom].x * 1.5,
    y: videoMode720[576][positions.rightBottom].y * 1.5
};
graphic[576][positions.leftBottom] = {
    width: graphic[576][positions.leftTop].width,
    height: graphic[576][positions.leftTop].height,
    x: videoMode720[576][positions.leftBottom].x * 1.5,
    y: videoMode720[576][positions.leftBottom].y * 1.5
};


graphic[720][positions.leftTop] = {
    width: videoMode720[720][positions.leftTop].width * 1.5,
    height: videoMode720[720][positions.leftTop].height * 1.5,
    x: videoMode720[720][positions.leftTop].x * 1.5,
    y: videoMode720[720][positions.leftTop].y * 1.5
};
graphic[720][positions.rightTop] = {
    width: graphic[720][positions.leftTop].width,
    height: graphic[720][positions.leftTop].height,
    x: videoMode720[720][positions.rightTop].x * 1.5,
    y: videoMode720[720][positions.rightTop].y * 1.5
};
graphic[720][positions.rightBottom] = {
    width: graphic[720][positions.leftTop].width,
    height: graphic[720][positions.leftTop].height,
    x: videoMode720[720][positions.rightBottom].x * 1.5,
    y: videoMode720[720][positions.rightBottom].y * 1.5
};
graphic[720][positions.leftBottom] = {
    width: graphic[720][positions.leftTop].width,
    height: graphic[720][positions.leftTop].height,
    x: videoMode720[720][positions.leftBottom].x * 1.5,
    y: videoMode720[720][positions.leftBottom].y * 1.5
};


// same values
graphic[1080] = graphic[720];


module.exports = graphic;
